import { SanityContentImageDto, SanityContentVideoDto, SanityPortableTextBlockDto } from "@modules/common/cms/sanityDto"
import { SanityContentBlock } from "@modules/common/cms/sanityType"
import { Config } from "@modules/config"
import { convertYoutubeLinkToEmbed } from "@modules/utils/convertYoutubeLink"
import { SanityClient, createClient } from "@sanity/client"
import imageUrlBuilder from "@sanity/image-url"
import { SanityImageSource } from "@sanity/image-url/lib/types/types"

const SANITY_CLIENT_CONFIGS = {
  dev: {
    projectId: "9w5rklaw",
    dataset: "production",
    useCdn: false,
    apiVersion: "2024-01-10",
    perspective: "previewDrafts" as const,
    token: Config.SANITY_PREVIEW_TOKEN,
  },
  demo: {
    projectId: "9w5rklaw",
    dataset: "production",
    useCdn: false,
    apiVersion: "2024-01-10",
    perspective: "previewDrafts" as const,
    token: Config.SANITY_PREVIEW_TOKEN,
  },
  prod: {
    projectId: "9w5rklaw",
    dataset: "production",
    useCdn: true,
    apiVersion: "2024-01-10", // use current date (YYYY-MM-DD) to target the latest API version
    perspective: "published" as const,
  },
}

export class SanityService {
  static client: SanityClient = createClient(SANITY_CLIENT_CONFIGS[Config.ENV])
  static imageBuilder: ReturnType<typeof imageUrlBuilder> = imageUrlBuilder(this.client)

  static buildImageUri(ImageObject: SanityImageSource) {
    return SanityService.imageBuilder.image(ImageObject).width(566).url()
  }

  static buildYoutubeVideoUri(videoObject: SanityContentVideoDto) {
    return convertYoutubeLinkToEmbed(videoObject.video_url)
  }

  static buildContentBlock(
    block?: (SanityPortableTextBlockDto | SanityContentImageDto | SanityContentVideoDto)[],
  ): SanityContentBlock {
    if (!block) {
      return []
    }

    return block.map((content) => {
      if (content._type === "content_image") {
        return {
          _type: content._type,
          _key: content._key,
          alt_text: content.alt_text,
          uri: SanityService.buildImageUri(content),
        }
      }

      if (content._type === "content_video") {
        return {
          _type: content._type,
          _key: content._key,
          alt_text: content.alt_text,
          uri: SanityService.buildYoutubeVideoUri(content),
        }
      }

      return content
    })
  }
}
